<template>
    <gofix-card :title="title" classHeader="mb-13" classContent="mb-0" class="position-relative">
        <p>{{ desc }}</p>
        <template  v-if="isShowChecklistChild">
            <div class="position-absolute" style="right: 50px; top: 8.5px; font-size: 16px;">
                <gofix-button
                    v-if="this.$checkRole(this.$accessModule.permit_to_work, 'update') && tableItems.length"
                    :disabled="isDisabledSave"
                    :loading="loadingSave"
                    @click="updateData"
                    label="SAVE">
                </gofix-button>
            </div>
            <b-row no-gutters>
                <template v-for="(item, index) in tableItems">
                    <b-col md="12" class="mb-13" :key="index" v-if="item.children.length == 0">
                        <checklist-entries :job="job" :section="item.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item" typeJob="PTW"></checklist-entries>
                    </b-col>
                    <template v-else>
                        <template v-for="(item1) in item.children">
                        <b-col md="12" class="mb-13" :key="item1.id">
                            <checklist-entries :job="job" :section="item.name + ' >> ' + item1.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item1" typeJob="PTW"></checklist-entries>
                        </b-col>
                        </template>
                    </template>
                </template>
            </b-row>
        </template>
        
        <b-row no-gutters class="mb-15" v-if="signatures">
            <b-col md="12" class="mb-3 d-flex align-items-center">
                <span v-if="isAllowEditComment" style="" @click="showModalComment" class="mr-2 mb-2 cursor-pointer">
                    <img src="img/iconPencil.png" alt="edit-comment" with="18px" height="18">
                </span>
                <gofix-text-field label="Comments" oneline>
                    {{ job && typeComment && job[typeComment] ? job[typeComment].description : '-' }}
                </gofix-text-field>
            </b-col>
            <b-col md="12">
                <b-table :fields="fields" :items="signatures" bordered fixed class="mb-0">
                    <template slot="user" slot-scope="row">
                        {{row.item.user && row.item.user.name ? row.item.user.name : '-' }}
                        <gofix-text-field label=" " class="photosThumb mt-2">
                            <template v-if="row.item.photos">
                                <viewer-image :images="row.item.photos">
                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                        <div v-for="(item_image, key) in images">
                                            <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif" width="200" class="mr-2">
                                        </div>
                                    </template>
                                </viewer-image>
                            </template>
                        </gofix-text-field>
                    </template>
                    <template slot="created_at" slot-scope="row">
                        {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                    </template>
                    <template slot="actual_created_at" slot-scope="row">
                        {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                    </template>
                    <template slot="signature" slot-scope="row">
                        <b-row>
                            <b-col md="6">
                                <gofix-text-field label=" " class="photosThumb mt-0" classInner="justify-content-end" oneline>
                                    <template v-if="row.item.attachments">
                                        <viewer-image :images="row.item.attachments" classViewer='d-flex align-items-center'>
                                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                <ul class="list-thumb signature_v2">
                                                    <template v-for="(item_image, key) in images">
                                                        <li :key="key">
                                                            <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif">
                                                        </li>
                                                    </template>
                                                </ul>
                                            </template>
                                        </viewer-image>
                                    </template>
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </template>
                </b-table>
            </b-col>

            <b-modal :no-close-on-backdrop="true" body-class="px-0" id="modal-Check-FollowUp" title="Comment" hide-footer :centered="true" v-model="modal.comment.open">
                <div class="pl-20 pr-20">
                    <b-form-group label="Comment" class="clear-both text-remark notFloat">
                        <b-form-textarea v-model="modal.comment.data.description" class="notFloat" rows="4"></b-form-textarea>
                    </b-form-group>
                    </b-form-group>
                </div>
                <b-button-group class="d-block text-right pl-10 pr-10">
                    <gofix-button :loading="modal.comment.loading" label="APPLY" @click="saveComment" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </b-row>
    </gofix-card>
</div>
</template>

<script>
    const ViewerImage = () => import('@/views/plugins/ViewerImage.vue')
    const checklistEntries = () => import("../detail-checklist")
    export default {
        name: 'detail-signature',
        components: {
            ViewerImage,
            checklistEntries
        },
        props: {
            signatures: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            desc: {
                type: String,
                default: ''
            },
            job: {
                type: Object,
                default: () => {}
            },
            typeComment: {
                type: String,
                default: null
            },
            isShowChecklistChild: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                fields: [
                    {
                        key: 'user',
                        label: 'By',
                        thStyle: 'width: 200px'
                    },
                    {
                        key: 'created_at',
                        label: 'Submit Date / Time',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'actual_created_at',
                        label: 'Actual Submit Date / Time',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'signature',
                        label: 'Signature',
                        thStyle: 'width: 150px'
                    },
                ],
                modal: {
                    comment: {
                        open: false,
                        loading: false,
                        data: {
                            description: ''
                        }
                    }
                },
                tableItems: [],
                checkListEntryUpdate: [],
                loadingCheckListEntry: false,
                isModalShow: false,
                isTyping: false,
                isSave: false,
                loadingSave: false,
                modals: {
                    remark: {
                        open: false,
                        checklistEntry: null
                    },
                },
            }
        },
        watch: {
            job: function(val, old){
                if(this.isShowChecklistChild && val && (!old || old && val.id != old.id)) {
                    this.getCheckListGroupData();
                }
            },
            isTyping: function(val) {
                if(val === false && this.isSave === true) {
                    this.updateData();
                }
            },
        },
        computed: {
            isAllowEditComment() {
                return this.$checkRole(this.$accessModule.permit_to_work, 'update') && 
                    (this.job && this.job.planned_date && new Date(this.job.planned_date).toDateString() === new Date().toDateString()) && 
                    (this.typeComment == 'comment_cs' || (this.typeComment != 'comment_cs' &&  this.job && this.job.related_id))
            },
            isDisabledSave() {
                return this.job && ((this.job.related_id && this.job.status != 'Submitted') || (this.job.planned_date && new Date(this.job.planned_date).toDateString() !== new Date().toDateString()));
            },
        },
        created() {
            if(this.isShowChecklistChild){
                this.getCheckListGroupData();
            }
        },
        methods: {
            showModalComment() {
                this.modal.comment.data.description = this.job && this.typeComment && this.job[this.typeComment] ? this.job[this.typeComment].description : '';
                this.modal.comment.open = true;
            },
            saveComment() {
                this.$store.dispatch("SafetyAppController/saveCommentPTW", {
                    id: this.job.id,
                    data: {
                        description: this.modal.comment.data.description,
                        type: this.typeComment
                    }
                }).then(() => {
                    this.$emit('reloadItem', this.job.id);
                    this.modal.comment.open = false;
                }).catch(() => {
                    this.modal.comment.open = false;
                });
            },
            async getCheckListGroupData(){
                if(!this.job || !this.job.id || (this.job && (!this.job.related_id))) {
                    this.tableItems = [];
                    return;
                }
                this.loadingCheckListEntry = true;
                await this.$store
                    .dispatch("SafetyAppController/getSafetyCheckListGroupData", this.job.id)
                    .then((result) => {
                        this.tableItems = result.items;
                        this.loadingCheckListEntry = false;
                        this.$emit('loadChecklistEntriesOfJobChild', this.tableItems)
                    })
                    .catch((err) => {
                        this.loadingCheckListEntry = false;
                });
            },
            reloadChecklist() {
                this.getCheckListGroupData();
            },
            async updateCheckListEntries(val){
                let params = val;
                let request = {
                    id: params.val.id,
                    value: params.val.input.value,
                    status: params.val.status,
                }
                if(params.val.hasOwnProperty('output')) request.output = params.val.output;
                if(params.val.hasOwnProperty('is_output_highlighted')) request.is_output_highlighted = params.val.is_output_highlighted;
                if(!params.from_status){
                    if(params.val.input.value){ request.status = params.val.status = 'Filled'; }
                    else{ request.status = params.val.status = 'Unfilled';}
                }

                let checkListEntryData = [request];
                if(this.checkListEntryUpdate.length > 0){
                    checkListEntryData = Object.assign([], this.checkListEntryUpdate);
                }
                let flag = false;
                if(checkListEntryData.length > 0){
                    for (let i = 0; i < checkListEntryData.length; i++) {
                        if (request && request.id == checkListEntryData[i].id) {
                            this.checkListEntryUpdate[i] = request;
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        this.checkListEntryUpdate.push(request);
                    }
                }
                this.isTyping = false;
            },
            selectChecklistEntry(entry) {
                this.modals.remark.checklistEntry = entry;
                this.modals.remark.open = true;
            },
            updateData() {
                if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(() => {
                    if(this.isTyping) {
                        this.isSave = true;
                        return;
                    }
                    if(this.isModalShow) return;
                    this.isSave = false;

                    var checkValidate = this.checkListEntryUpdate.filter(function(item) {
                        return (item.status === 'Filled' && !item.value);
                    });
                    if(checkValidate.length > 0){
                        return this.$alertNotification("Please enter checklist entries value when the status Filled", "danger");
                    }
                    this.loadingSave = true;
                    let request = {
                        array_data: JSON.stringify(this.checkListEntryUpdate),
                        job_id: this.job.id
                    };
                    this.$store
                        .dispatch("SafetyAppController/updateCheckListJob", request)
                        .then(async (data) => {
                            // await this.getItem();
                            this.loadingSave = await false;
                            this.checkListEntryUpdate = [];
                            this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        })
                        .catch((err) => {
                            this.$alertNotification("Can not update checklist!", "danger");
                        });
                }, 100);
            },
        }
    }
</script>
